export default "__VITE_ASSET__c0efa86c__"